// @ts-check
import { ModuleProcessMappings } from '@erpagroapp/common';
import {
  ConfigurationParameterReturnType,
  ConfigurationParameterSource,
} from '../enums';
import { defineConfig, defineDefaultProps } from '../helpers';

const defaultProps = defineDefaultProps(/** @type {const} */ ({
  loadingRules: {
    requiredModuleIds: [
      ModuleProcessMappings.Warehouse.Id,
    ],
  },
}));

export function warehouse() {
  return defineConfig({
    RecuentoACiegasAPP: {
      source: ConfigurationParameterSource.ERP,
      component: 'Almacen',
      returnType: ConfigurationParameterReturnType.BOOLEAN,
      defaultValue: false,
      loadingRules: {
        ...defaultProps.loadingRules,
        requiredProcessIds: [
          ModuleProcessMappings.Warehouse.Processes.InventoryRegularization.Id,
        ],
      },
    },
    NoPermitirAvanzarEnGestionUbicacionesAPP: {
      source: ConfigurationParameterSource.ERP,
      component: 'Almacen',
      returnType: ConfigurationParameterReturnType.BOOLEAN,
      defaultValue: false,
      loadingRules: {
        ...defaultProps.loadingRules,
        requiredProcessIds: [
          ModuleProcessMappings.Warehouse.Processes.ManageSalesLocation.Id,
          ModuleProcessMappings.Warehouse.Processes.ManageShoppingLocation.Id,
        ],
      },
    },
  });
}
